const NewMovieCardSkeleton = () => {
    return (
        <div className={`w-72 md:w-96 shrink-0`}>
            <div className="animate-pulse flex flex-col space-y-1">
                <div className="aspect-video w-full bg-neutral-700 rounded-lg"></div>
                <div className="w-3/4 bg-neutral-700 h-6 rounded-lg"></div>
                <div className="w-2/4 bg-neutral-700 h-5 rounded-lg"></div>
                <div className="w-1/4 bg-neutral-700 h-4 rounded-lg"></div>
                <div className="w-full bg-neutral-700 h-0.5 rounded-full"></div>
            </div>
        </div>
    );
};
export default NewMovieCardSkeleton;
